import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

import { CustomGridColumns } from '~/components/CustomDataGrid/protocols';

import { tableItensColumns } from './TableItens';

import { ScrollButtonsContainer } from './styles';

const buttons = [
  { field: 'num_item', label: 'Identificador' },
  { field: 'qtd_embalagem_venda', label: 'Quantidade' },
  { field: 'val_desconto', label: 'Variáveis' },
  { field: 'val_tabela_liq', label: 'ICMS' },
  { field: 'val_icms_st', label: 'ST' },
  { field: 'tipo_tributacao', label: 'Tributação' },
  { field: 'cod_ibs_cbs', label: 'IBS/CBS' },
];

interface ScrollButtonProps extends ButtonProps {
  field: string;
}

const ScrollButton = ({ field, ...rest }: ScrollButtonProps) => {
  return <Button {...rest} onClick={() => scroll(field)} />;
};

const scroll = (field: string) => {
  const index = tableItensColumns.findIndex(
    (column: CustomGridColumns) => column.field === field,
  );
  const columns = tableItensColumns.slice(0, index);
  let offset = 0;
  columns.map((column: CustomGridColumns, _index) => {
    if (_index + 1 !== columns.length) {
      offset += column.width || 0;
    }
    return column;
  });
  if (offset === 0) {
    document.getElementsByClassName(
      'tableEmissaoNFeContainer',
    )[0].scrollLeft = 0;
    return;
  }
  const tableElement = document.querySelector<HTMLElement>('#tableEmissaoNFe');
  const tableWidth = tableElement?.offsetWidth || 0;
  if (offset >= tableWidth) {
    document.getElementsByClassName('tableEmissaoNFeContainer')[0].scrollLeft =
      tableWidth;
    return;
  }
  document.getElementsByClassName('tableEmissaoNFeContainer')[0].scrollLeft =
    offset;
};

export const ScrollButtons: React.FC = () => {
  return (
    <ScrollButtonsContainer>
      {buttons.map((button) => (
        <ScrollButton key={button.field} field={button.field}>
          {button.label}
        </ScrollButton>
      ))}
    </ScrollButtonsContainer>
  );
};
